import React from 'react';

import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, Flex } from '@betterment/style-closet-react';

import { useCoPilotSectionState } from '../../contexts/CoPilotSectionContext';

const BottomRail: React.FC<React.PropsWithChildren<{ hasTableFooter: boolean }>> = ({ hasTableFooter }) => {
  const { status, handleSendReminder, handleToggleModal, canSendReminders } = useCoPilotSectionState();

  if (['empty', 'loading', 'fetchError'].includes(status)) {
    return !hasTableFooter && <Box height="100px" />;
  }

  if (status === 'idle') {
    return (
      <Flex
        // @ts-expect-error TS2322 violates strict null checks
        borderBottom={hasTableFooter && '1px solid'}
        borderColor="bmtGrey20"
        pl={6}
        py={4}
        height="100px"
        alignItems="center"
      >
        <Flex alignItems="center">
          <Icon name="Lightbulb" size="small" color="icon.weak" />
          <Box pl={2}>
            <Text color="text.weak">Select a client to get started</Text>
          </Box>
        </Flex>
      </Flex>
    );
  }
  return (
    <Flex
      // @ts-expect-error TS2322 violates strict null checks
      borderBottom={hasTableFooter && '1px solid'}
      borderColor="bmtGrey20"
      pl={6}
      py={4}
      height="100px"
      alignItems="center"
    >
      <Flex alignItems="center">
        {canSendReminders && (
          <Box mr={5}>
            <Button onClick={() => handleSendReminder()}>Send reminder</Button>
          </Box>
        )}
        <Button onClick={() => handleToggleModal()} variant="secondary">
          Remove from list
        </Button>
      </Flex>
    </Flex>
  );
};

export default BottomRail;
